module.exports = __webpack_public_path__ + "images/FUSA_icons/046-online-shop-4.fbe0a3c82570f1638a9f0201d9f2f136.svg";